export function pluralOrSingularPoints(qnt: number) {
	if (Math.abs(qnt) === 1) return 'point';
	return 'points';
}
